export const graphColors = ["#36a2eb", "#2b81bc", "#20618d", "#15405E"];
